export default __webpack_public_path__ + "cfea04f1a953069200ea4fc607d7fea4.png";